import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs = [{
  q: '¿Necesito experiencia previa para empezar?',
  a: 'No, el programa está diseñado para comenzar completamente desde cero. No importa tu condición física actual ni cuánto tiempo llevas sin hacer ninguna actividad. Todo empieza de forma gradual y a tu ritmo.'
}, {
  q: '¿Cuánto tiempo por día necesito dedicarle?',
  a: 'Con 30 a 45 minutos diarios es más que suficiente. El plan está pensado especialmente para personas con agenda ocupada que buscan resultados reales sin sacrificar horas de su día.'
}, {
  q: '¿Funciona si tengo sobrepeso importante?',
  a: 'Sí, de hecho la caminata es especialmente recomendada para personas con sobrepeso porque es de bajo impacto articular y muy efectiva para activar el metabolismo de forma segura y progresiva.'
}, {
  q: '¿Cuánto tiempo tengo acceso al contenido?',
  a: 'El acceso es de por vida. Una vez que te inscribís, todo el contenido es tuyo para siempre, incluyendo todas las actualizaciones que se agreguen en el futuro.'
}, {
  q: '¿Puedo pagar en cuotas?',
  a: 'Sí, contamos con opciones de pago en cuotas. Al hacer clic en el botón de inscripción vas a ver todas las opciones disponibles según tu país y método de pago.'
}, {
  q: '¿Hay garantía si no quedo satisfecho/a?',
  a: 'Absolutamente. Ofrecemos 7 días de garantía total. Si por cualquier motivo el programa no es lo que esperabas, te devolvemos el dinero completo sin preguntas, sin formularios y sin complicaciones.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white" data-id="element-29" data-mp="1q95vusk0x8q">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-24" data-id="element-30" data-mp="3jxq5nn9agjg6">
        <Reveal className="text-center" data-id="element-31" data-mp="3k0cdzp4072zg">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-32" data-mp="3nztmkreq8g8u">
            Preguntas frecuentes
          </h2>
        </Reveal>

        <div className="mt-12 space-y-3" data-id="element-33" data-mp="1uixnzcj23ral">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <Reveal key={faq.q} delay={i % 3 * 0.05} data-id="element-34" data-mp="1kqi5me3ul0p6" data-mpi={i}>
                <div className="overflow-hidden rounded-2xl border border-ink/10 bg-cream" data-id="element-35" data-mp="1koyokladalmc">
                  <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left" data-id="element-36" data-mp="1ftrm1gsu3mz0">
                    <span className="text-base font-bold text-ink" data-id="element-37" data-mp="23gzs40y37023">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-brand transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-38" data-mp="1zfxprb8vi7vw" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="nz7hznosx806">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-40" data-mp="2zpfbgfp8hwrm">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-ink/70" data-id="element-41" data-mp="3dh3lmdfxab5y">{faq.a}</p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}